import { tw } from "@careinfo/tailwind";
import loadable from "@loadable/component";
import { useState } from "react";
import { toast } from "react-toastify";
import APIS from "../../constant/Endpoint";
import useDeleteHook from "../../hooks/useDeleteHook";
import usePatchHook from "../../hooks/usePatchHook";
import OverViewIcon from "../../icons/OverViewIcon copy";

const PopupModalListComponent = loadable(
  () => import("../../components/PopupModal/List"),
  {
    fallback: (() => {
      return <p>Loading</p>;
    })(),
  }
);

export default function PopupModalList() {
  const [showDeletModal, setShowDeleteModal] = useState(false);

  const { mutateAsync: deletePage, isLoading: isDeletingPage } = useDeleteHook({
    queryKey: ["delete-page"],
  });

  const { mutateAsync: updatePage, isLoading: isUpdatingPage } = usePatchHook({
    queryKey: [`update-page-details`],
    navigateURL: "/website-builder/pages",
  });

  const handleDelete = async (id: string) => {
    try {
      const url = `${APIS.POPUP}${id}/`;
      await deletePage({ url });
      setShowDeleteModal(false);
    } catch (error) {
      if (error instanceof Error) toast.error(error.message);
    }
  };

  const handlePublic = async (value: boolean, id: string): Promise<void> => {
    try {
      const url = `${APIS.POPUP}${id}/`;
      await updatePage({
        url,
        formData: {
          is_published: value,
        },
      });
    } catch (error) {
      if (error instanceof Error) toast.error(error.message);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <OverViewIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Popup Modal
        </span>
      </div>
      <div>
        <PopupModalListComponent
          showDeleteModal={showDeletModal}
          setShowDeleteModal={setShowDeleteModal}
          handleDelete={handleDelete}
          isDeletingPage={isDeletingPage}
          isUpdatignPage={isUpdatingPage}
          handlePublic={handlePublic}
        />
      </div>
    </>
  );
}
